/**
 * Styled note. Body is plain text; evidence tokens stay visible until findings land.
 */
import { el } from '../../core/dom.js';
import { resolvedOf } from './shape.js';

const VARIANTS = new Set(['insight', 'warning', 'gap', 'recommendation', 'critical']);

/**
 * @param {object} block
 * @returns {HTMLElement}
 */
export function renderCallout(block) {
  const data = resolvedOf(block);
  const variant = VARIANTS.has(data.variant) ? data.variant : 'insight';
  const alert = variant === 'critical' || variant === 'warning';
  return el('aside', {
    class: `chat-block chat-callout is-${variant}`,
    role: alert ? 'alert' : 'note',
    'data-block-type': 'callout',
    'data-block-id': (block && block.id) || '',
    'aria-label': data.title ? String(data.title) : variant,
  },
  data.title ? el('h3', { class: 'chat-block-title' }, String(data.title)) : null,
  el('p', {}, data.body == null ? '' : String(data.body)));
}
